import { useState } from 'react';

interface TableRow {
  id: string;
  date: string;
  pricingType?: string;
  pricingTypeArticleNumber?: string;
  service: string;
  customWorkingDescription?: string;
  time: string;
  price: string;
  discount: { value: number; type: 'percentage' | 'fixed' };
  subtotal: number;
}

interface ServiceTableData {
  totalAmount: number;
  hourlyWagesAmount: number;
  workingHours: Array<{
    id: number;
    workingDate: string;
    dateId: string;
    number: number;
    unit: string;
    vat: number;
    isArticleShownInInvoice: boolean;
    amountPerUnit: number;
    amount: number;
    articleNumber: string;
    workingDescription: string;
    houseworkType: string;
    workingHour: number;
    CustomWorkingDescription: string;
  }>;
}

interface PensionData {
  pension: boolean;
  pensionAmount: number;
}

interface HolidayData {
  holidaySavings: boolean;
  holidaySavingsFee: number;
}

export const useFreelancerState = () => {
  // State for table rows - SEPARATE for each freelancer indexed by freelancerId/userId
  const [tableRowsByFreelancer, setTableRowsByFreelancer] = useState<{
    [freelancerId: string]: TableRow[];
  }>({});

  // State for service table calculated data - SEPARATE for each freelancer
  const [serviceTableDataByFreelancer, setServiceTableDataByFreelancer] = useState<{
    [freelancerId: string]: ServiceTableData;
  }>({});

  // State for pension data per freelancer
  const [pensionDataByFreelancer, setPensionDataByFreelancer] = useState<{
    [freelancerId: string]: PensionData;
  }>({});

  // State for holiday savings data per freelancer
  const [holidayDataByFreelancer, setHolidayDataByFreelancer] = useState<{
    [freelancerId: string]: HolidayData;
  }>({});

  // State to store deductions (tax-free articles) for each freelancer
  const [deductionsByFreelancer, setDeductionsByFreelancer] = useState<{
    [freelancerId: string]: any[];
  }>({});

  // State for selected dates (to show in calendar) - SEPARATE for each freelancer
  const [calendarSelectedDatesByFreelancer, setCalendarSelectedDatesByFreelancer] = useState<{
    [freelancerId: string]: Date[];
  }>({});

  // State for last used pricing type PER FREELANCER (to remember user's preference per freelancer)
  const [lastUsedPricingTypeByFreelancer, setLastUsedPricingTypeByFreelancer] = useState<{
    [freelancerId: string]: string;
  }>({});

  // State to track expanded sections for each freelancer
  const [expandedSections, setExpandedSections] = useState<{
    [freelancerId: string]: boolean;
  }>({});

  // State to track removed working hours from copiedInvoiceData
  const [removedCopiedWorkingHours, setRemovedCopiedWorkingHours] = useState<Set<number>>(new Set());

  return {
    // Table rows state
    tableRowsByFreelancer,
    setTableRowsByFreelancer,
    
    // Service table data state
    serviceTableDataByFreelancer,
    setServiceTableDataByFreelancer,
    
    // Pension data state
    pensionDataByFreelancer,
    setPensionDataByFreelancer,
    
    // Holiday data state
    holidayDataByFreelancer,
    setHolidayDataByFreelancer,
    
    // Deductions state
    deductionsByFreelancer,
    setDeductionsByFreelancer,
    
    // Calendar dates state
    calendarSelectedDatesByFreelancer,
    setCalendarSelectedDatesByFreelancer,
    
    // Pricing type state
    lastUsedPricingTypeByFreelancer,
    setLastUsedPricingTypeByFreelancer,
    
    // Expanded sections state
    expandedSections,
    setExpandedSections,
    
    // Removed working hours state
    removedCopiedWorkingHours,
    setRemovedCopiedWorkingHours,
  };
};
